import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// This consumes a PUBLIC signed authorization, never a user-entered JWT.
// The source AuthProvider performs the body exchange and token handoff.
export default function CanaryOperatorSignIn({ onBack }) {
  const { beginCanarySignIn, completeCanarySignIn } = useAuth();
  const navigate = useNavigate();
  const [studentId, setStudentId] = useState('five001');
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const begin = async () => {
    setBusy(true); setError('');
    try { setState(await beginCanarySignIn(studentId)); }
    catch { setError('Scoped sign-in is unavailable. Source registration and the open, ready five-canary grant are required.'); }
    finally { setBusy(false); }
  };
  const exchange = async (event) => {
    const file = event.target.files?.[0]; event.target.value = '';
    if (!file || !state || busy) return;
    setBusy(true); setError('');
    try {
      if (file.size > 24000) throw new Error();
      const authorization = JSON.parse(await file.text());
      if (Object.keys(authorization).sort().join(',') !== 'payloadBase64,signatureBase64') throw new Error();
      const redirectPath = await completeCanarySignIn(authorization);
      navigate(redirectPath, { replace: true });
    } catch { setError('Scoped sign-in was refused. Do not retry a spent authorization; return to the source reviewer.'); }
    finally { setBusy(false); }
  };
  return <main style={{ maxWidth: 620, margin: '10vh auto', padding: 24 }}>
    <h1>Scoped operator sign-in</h1>
    <p>For the five owned synthetic canaries only. An independently purpose-signed authorization is required; this page cannot issue one.</p>
    {error && <p role="alert">{error}</p>}
    {!state ? <>
      <label htmlFor="canary-student">Synthetic identity</label>
      <select id="canary-student" value={studentId} onChange={event => setStudentId(event.target.value)} disabled={busy}>
        {[1, 2, 3, 4, 5].map(number => <option key={number}>{`five00${number}`}</option>)}
      </select>
      <button type="button" onClick={begin} disabled={busy}>Request browser-bound state</button>
    </> : <>
      <p>Have the source reviewer sign this public state before its original 60-second deadline. No private key belongs in this browser.</p>
      <pre aria-label="Public sign-in state" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{JSON.stringify(state, null, 2)}</pre>
      <label htmlFor="canary-authorization">Reviewed public authorization JSON</label>
      <input id="canary-authorization" type="file" accept=".json,application/json" disabled={busy} onChange={exchange} />
    </>}
    {busy && <p role="status">Validating the current canary grant…</p>}
    <p><button type="button" onClick={onBack} disabled={busy}>Return to student OTP sign-in</button></p>
  </main>;
}
